"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("./errors");
const index_1 = require("./index");
/**
 * Indicates a success reply and contains the value and other information.
 */
class SuccessReply {
    constructor(value) {
        this.value = value;
        this.kind = ReplyKind.Ok;
    }
    toString() {
        return `SuccessReply: ${this.value}`;
    }
}
exports.SuccessReply = SuccessReply;
class FailureReply {
    constructor(trace) {
        this.trace = trace;
    }
    get value() {
        throw new errors_1.ParjsParsingFailure(this);
    }
    get kind() {
        return this.trace.kind;
    }
    toString() {
        return index_1.Parjs.visualizer(this.trace);
    }
}
exports.FailureReply = FailureReply;
/**
 * Namespace that contains the different reply kinds/error levels.
 */
var ReplyKind;
(function (ReplyKind) {
    /**
     * An Unknown reply.
     */
    ReplyKind.Unknown = "Unknown";
    /**
     * An OK reply.
     */
    ReplyKind.Ok = "OK";
    /**
     * A soft failure reply.
     */
    ReplyKind.SoftFail = "Soft";
    /**
     * A hard failure reply.
     */
    ReplyKind.HardFail = "Hard";
    /**
     * A fatal failure reply.
     */
    ReplyKind.FatalFail = "Fatal";
})(ReplyKind = exports.ReplyKind || (exports.ReplyKind = {}));
//# sourceMappingURL=reply.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/parjs/reply.js
// module id = 12
// module chunks = 0 1